/* global FormData */

define([
  'jquery',
  'axios',
  'immutable',
  'underscore',
  'js-cookie',
  'react-router',
  'es6!sumo/util',
  'es6!launcher/util/listbuilder/wysiwyg/sanitize',
  'es6!launcher/util/listbuilder/wysiwyg/templates',
  'es6!sumo/list/actions/Actions',
  'es6!launcher/actions/ListBuilderActions',
  'es6!launcher/actions/DisplayRuleAppActions',
  'es6!launcher/actions/DiscountAppActions',
  'es6!launcher/util/listbuilder/constants',
  'es6!launcher/util/listbuilder/styleTemplate',
  'es6!launcher/util/utils',
], (
  $, axios, Immutable, _, jscookie, ReactRouter, Util, WysiwygSanitize,
  WysiwygTemplates, ListActions, Actions, DisplayRuleAppActions,
  DiscountAppActions, Constants, StyleTemplate, { getFilterGroups },
) => {
  const { FEATURES } = Util.Constants;
  const {
    FormTypes,
    APP_ID,
    DEFAULT_TEMPLATE_ID,
    LB_TEST_FILTER_ORDER,
  } = Constants;

  function _getRequestConfig() {
    return {
      withCredentials: false,
      headers: {
        'X-Sumo-Auth': jscookie.get('__smToken'),
      },
    };
  }

  function _receivePopupIds(popups) {
    return {
      type: Actions.RECEIVE_POPUP_IDS,
      popups,
    };
  }

  function _requestPopups() {
    return {
      type: Actions.REQUEST_POPUPS,
    };
  }

  function _receiveTestPopups(popups, clear) {
    return {
      type: Actions.RECEIVE_TEST_POPUPS,
      popups,
      clear,
    };
  }

  function _receivePopups(popups, migrateListBuilder, migrateScrollBox, migrateSmartBar, migrateWelcomeMat) {
    return {
      type: Actions.RECEIVE_POPUPS,
      popups,
      migrateListBuilder,
      migrateScrollBox,
      migrateSmartBar,
      migrateWelcomeMat,
    };
  }

  function _errorPopups(code, error) {
    return {
      type: Actions.ERROR_POPUPS,
      code,
      error,
    };
  }

  function _fetchPopupStats({
    sumoUrl,
    siteId,
    popups,
    onStatsRecieved,
  }) {
    if (popups) {
      const idList = popups.map((p) => p.id);
      axios.post(`${sumoUrl}/apps/listbuilder/v3/popup-stats`, {
        site_id: siteId,
        popup_id: idList,
      }, _getRequestConfig())
      .then((statsResponse) => {
        const mergedPopups = popups.map((popup) => {
          popup.isStatsLoaded = true;
          const stats = statsResponse.data.stats[popup.id];
          if (stats) {
            return {...popup, ...stats};
          }
          return popup;
        });
        onStatsRecieved(mergedPopups);
      });
    }
  }

  function fetchTestPopups(clear = false) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');
      const page = clear ? 1 : getState().popups.get('loadedPages') + 1;
      const limit = 10;
      const formType = _.values(FormTypes);
      const status = ['active', 'paused'];
      const name = '';
      const sortKey = 'updated_at desc';

      return axios.post(`${sumoUrl}/apps/listbuilder/v3/popups`, {
        site_id: siteId,
        form_type: formType,
        sort_key: sortKey,
        status,
        name,
        page,
        limit,
      }, _getRequestConfig())

      .then(res => {
        if (!res.data.success) {
          throw new Error('Failed to load testable popups.');
        }

        const { popups } = res.data;
        _fetchPopupStats({
          sumoUrl,
          siteId,
          popups,
          onStatsRecieved: (stats) => dispatch(_receiveTestPopups(stats, clear)),
        });

        return dispatch(_receiveTestPopups(popups, clear));
      })

      .catch(error => {
        // dispatch(_errorPopups('fetch', error));
        console.log(error);
      });
    };
  }

  function fetchPopups(refresh = false) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');
      const page = getState().listbuilderSettings.get('page');
      const limit = getState().listbuilderSettings.get('limit');
      let formType = getState().listbuilderSettings.get('formType');
      const status = getState().listbuilderSettings.get('status');
      const name = getState().listbuilderSettings.get('name');
      const sortKey = getState().listbuilderSettings.get('sortKey');
      const fetchedAt = getState().popups.get('fetchedAt');

      if (refresh === false) {
        const cacheAge = (Date.now() - fetchedAt) / 1000;

        if (cacheAge <= 300) {
          return Promise.resolve();
        }
      }

      // Lump cart casino forms with popups (hardly used and not for new users)
      if (formType.includes(FormTypes.POPUP)) {
        formType.push(FormTypes.GAME);
      } else {
        formType = formType.filter(type => type !== FormTypes.GAME);
      }

      dispatch(_requestPopups());
      return axios.post(`${sumoUrl}/apps/listbuilder/v3/popups`, {
        site_id: siteId,
        form_type: formType,
        sort_key: sortKey,
        status,
        name,
        page,
        limit,
      }, _getRequestConfig())

      .then(res => {
        if (!res.data.success) {
          throw new Error('Failed to load popups.');
        }

        // TODO: Maybe move migrateListBuilder, etc. into settings...
        dispatch(updateSetting('total', res.data.total));
        dispatch(updateSetting('hasPopups', res.data.hasPopups));

        const {
          popups,
          migrateListBuilder,
          migrateScrollBox,
          migrateSmartBar,
          migrateWelcomeMat,
        } = res.data;

        _fetchPopupStats({
          sumoUrl,
          siteId,
          popups,
          onStatsRecieved: (stats) => dispatch(_receivePopups(
            stats,
            migrateListBuilder,
            migrateScrollBox,
            migrateSmartBar,
            migrateWelcomeMat,
          )),
        });

        return dispatch(_receivePopups(
          popups,
          migrateListBuilder,
          migrateScrollBox,
          migrateSmartBar,
          migrateWelcomeMat,
        ));
      })

      .catch(error => {
        dispatch(_errorPopups('fetch', error));
        console.log(error);
      });
    }
  }

  function updateListBuilderCandidates(candidates) {
    return {
      type: Actions.UPDATE_LIST_BUILDER_CANDIDATES,
      candidates,
    };
  }

  function updateScrollBoxCandidates(candidates) {
    return {
      type: Actions.UPDATE_SCROLL_BOX_CANDIDATES,
      candidates,
    };
  }

  function updateSmartBarCandidates(candidates) {
    return {
      type: Actions.UPDATE_SMART_BAR_CANDIDATES,
      candidates,
    };
  }

  function updateWelcomeMatCandidates(candidates) {
    return {
      type: Actions.UPDATE_WELCOME_MAT_CANDIDATES,
      candidates,
    };
  }

  function updatePopupRowLayout(popupId, popupStep, layoutPreset) {
    return {
      popupId,
      popupStep,
      layoutPreset,
      type: Actions.UPDATE_POPUP_ROW_LAYOUT,
    };
  }

  function _requestPopup(popupId) {
    return {
      type: Actions.REQUEST_POPUP,
      id: popupId,
    };
  }

  function _receivePopup(popup, resetFetch) {
    return {
      type: Actions.RECEIVE_POPUP,
      popup,
      resetFetch,
    };
  }

  function _errorPopup(popupId, code, error) {
    return {
      type: Actions.ERROR_POPUP,
      popupId,
      code,
      error,
    };
  }

  function updateScrapeStatus(status) {
    return {
      type: Actions.UPDATE_SCRAPE_STATUS,
      status,
    };
  }

  function fetchPopup(popupId) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');

      dispatch(_requestPopup(popupId));

      return axios.post(`${sumoUrl}/apps/listbuilder/v3/popup/load`, {
        site_id: siteId,
        popup_id: popupId,
      }, _getRequestConfig())

      .then((res) => {
        const data = res.data;

        if (!data.success) {
          console.log('Failed to load popup');
          return Promise.resolve();
        }

        return Promise.all([
          dispatch(_receivePopup(res.data.popup)),
          dispatch(DisplayRuleAppActions.fetchDisplayRules(res.data.popup.campaign_id)),
          dispatch(ListActions.fetchServiceSettings(APP_ID, 'formsync', res.data.popup.campaign_id)),
        ]).then(() => res.data.popup);
      })

      .catch((err) => {
        dispatch(_errorPopup(popupId, 'fetch', err));
        console.log(err);
      });
    };
  }

  function createTest(popupId) {
    return (dispatch, getState) => {
      return dispatch(fetchPopup(popupId)).then(popup => {
        const state = getState();
        const templates = state.templates.get('byId');
        let newPopup = _.extend({}, popup);

        if (!templates) return Promise.resolve(null);
        const defaultTemplate = templates.get(DEFAULT_TEMPLATE_ID);
        if (!defaultTemplate) return Promise.resolve(null);

        delete newPopup.legacy_id;
        delete newPopup.legacy_campaign_id;
        delete newPopup.legacy_popup_id;
        delete newPopup.legacy_app_id;
        newPopup.id = _.uniqueId('new-');
        newPopup.name = 'Variant B';
        newPopup.variant = 'B';
        newPopup.status = 'active';
        newPopup.is_legacy_test = !!popup.legacy_id;

        if (!newPopup.list_builder_template_id) newPopup.list_builder_template_id = DEFAULT_TEMPLATE_ID;
        if (!newPopup.animation_id) newPopup.animation_id = DEFAULT_TEMPLATE_ID;
        if (!newPopup.json || newPopup.json === '{}') newPopup.json = defaultTemplate.get('json');
        if (!newPopup.visibility_mode) newPopup.visibility_mode = 'default';

        for (let i = 0; i < newPopup.auto_responses.length; i++) {
          newPopup.auto_responses[i].id = null;
          if (newPopup.auto_responses[i].status === 'active') {
            newPopup.auto_responses[i].status = 'inactive';
          }
        }

        return Promise.all([
          dispatch(_receivePopup(newPopup)),
        ]).then(() => newPopup);
      });
    };
  }

  function addTestVariant(popupId) {
    return (dispatch, getState) => (
      dispatch(fetchPopup(popupId)).then((popup) => {
        const state = getState();
        const templates = state.templates.get('byId');

        const test = (
          getState().tests.get('list', Immutable.List()).find(t => !!t.find(v => v.get('id') === popupId))
          || Immutable.List()
        ).toJS();

        const variant = String.fromCharCode(_.max(_.pluck(test, 'variant'), v => v.charCodeAt(0)).charCodeAt(0) + 1);
        const newPopup = { ...popup };

        if (!templates) return Promise.resolve(null);
        const defaultTemplate = templates.get(DEFAULT_TEMPLATE_ID);

        if (!defaultTemplate) return Promise.resolve(null);

        delete newPopup.legacy_id;
        delete newPopup.legacy_popup_id;
        delete newPopup.legacy_campaign_id;
        newPopup.id = _.uniqueId('new-');
        newPopup.name = `Variant ${variant}`;
        newPopup.variant = variant;

        if (!newPopup.list_builder_template_id) {
          newPopup.list_builder_template_id = DEFAULT_TEMPLATE_ID;
        }

        if (!newPopup.animation_id) newPopup.animation_id = DEFAULT_TEMPLATE_ID;
        if (!newPopup.json || newPopup.json === '{}') newPopup.json = defaultTemplate.get('json');
        if (!newPopup.visibility_mode) newPopup.visibility_mode = 'default';

        for (let i = 0; i < newPopup.auto_responses.length; i += 1) {
          newPopup.auto_responses[i].id = null;
          if (newPopup.auto_responses[i].status === 'active') {
            newPopup.auto_responses[i].status = 'inactive';
          }
        }

        return Promise.all([
          dispatch(_receivePopup(newPopup)),
        ]).then(() => newPopup);
      }).catch((err) => {
        console.log('Error fetching popup:', err);
      })
    );
  }

  function cloneVariant(popupId, variantId) {
    return (dispatch, getState) => {
      return dispatch(fetchPopup(variantId)).then(popup => {
        const objectDisplayRulesById = getState().displayRules.get('byObjectId').get(popup.campaign_id);
        const test = getState().tests.get('byId').get(popupId);
        let newPopup = _.extend({}, popup);

        delete newPopup.legacy_id;
        delete newPopup.legacy_popup_id;
        delete newPopup.legacy_campaign_id;
        delete newPopup.test_id;
        newPopup.campaign_id = _.uniqueId('new-');;
        newPopup.id = _.uniqueId('new-');
        newPopup.variant = 'A';
        newPopup.status = 'paused';
        newPopup.name = test.get(0).get('name');

        if (objectDisplayRulesById) {
          const objectDisplayRules = _.each(_.flatten(_.values(objectDisplayRulesById.toJS())), (displayRule) => {
            displayRule.id = _.uniqueId('new-');
            displayRule.object_id = newPopup.campaign_id;
          });

          dispatch(DisplayRuleAppActions.receiveDisplayRules(objectDisplayRules));
        }

        for (let i = 0; i < newPopup.auto_responses.length; i++) {
          newPopup.auto_responses[i].id = null;
          if (newPopup.auto_responses[i].status === 'active') {
            newPopup.auto_responses[i].status = 'inactive';
          }
        }

        return Promise.all([
          dispatch(_receivePopup(newPopup)),
        ])
          .then(() => newPopup);
      });
    };
  }

  function duplicateTestVariant(popupId, variantId, newName) {
    return (dispatch, getState) => {
      return dispatch(fetchPopup(variantId)).then((popup) => {
        const test = getState().tests.getIn(['byId', popupId]).toJS();
        const variant = String.fromCharCode(_.max(_.pluck(test, 'variant'), variant => variant.charCodeAt(0)).charCodeAt(0)+1);
        let newPopup = _.extend({}, popup);

        delete newPopup.legacy_id;
        delete newPopup.legacy_popup_id;
        delete newPopup.legacy_campaign_id;
        newPopup.id = _.uniqueId('new-');
        newPopup.name = newName;
        newPopup.variant = variant;

        if (!newPopup.list_builder_template_id) newPopup.list_builder_template_id = DEFAULT_TEMPLATE_ID;
        if (!newPopup.animation_id) newPopup.animation_id = DEFAULT_TEMPLATE_ID;

        if (newPopup.auto_responses) {
          newPopup.auto_responses.forEach((val) => {
            val.id = null;
            if (val.status === 'active') {
              val.status = 'inactive';
            }
          });
        }

        return Promise.all([
          dispatch(_receivePopup(newPopup, true)),
        ])
        .then(() => newPopup);
      });
    };
  }

  function resetClickTrigger(trigger) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      return new Promise(resolve => {
        Util.getUUID({ properties: { sumoUrl: sumoUrl } }, uuid => {
          trigger.id = uuid;
          trigger.campaign = null;
          return resolve(trigger);
        })
      });
    }
  }

  function duplicatePopup(popupId, newName) {
    return (dispatch, getState) => {
      return dispatch(fetchPopup(popupId)).then(popup => {
        const clickTriggerResets = [];
        let newPopup = _.extend({}, popup);

        newPopup.id = _.uniqueId('new-');
        newPopup.campaign_id = _.uniqueId('new-');
        newPopup.name = newName;

        for (let i = 0; i < newPopup.click_triggers.length; i++) {
          clickTriggerResets.push(dispatch(resetClickTrigger(newPopup.click_triggers[i])));
        }

        for (let i = 0; i < newPopup.auto_responses.length; i++) {
          newPopup.auto_responses[i].id = null;
          if (newPopup.auto_responses[i].status === 'active') {
            newPopup.auto_responses[i].status = 'inactive';
          }
        }

        const objectDisplayRulesById = getState().displayRules.get('byObjectId').get(popup.campaign_id);

        if (objectDisplayRulesById) {
          const objectDisplayRules = _.each(_.flatten(_.values(objectDisplayRulesById.toJS())), (displayRule) => {
            displayRule.id = _.uniqueId('new-');
            displayRule.object_id = newPopup.campaign_id;
          });

          dispatch(DisplayRuleAppActions.receiveDisplayRules(objectDisplayRules));
        }

        return Promise.all([
          ...clickTriggerResets,
        ])
        .then((clickTriggers) => {
          newPopup.click_triggers = clickTriggers;
          return Promise.all([
            dispatch(_receivePopup(newPopup, true)),
          ])
          .then(() => newPopup);
        });
      });
    }
  }

  function deletePopup(popupId) {
    return {
      type: Actions.DELETE_POPUP,
      popupId,
    };
  }

  function _generateFormPopup(popupId, wysiwygPopupMode, templateJSON) {
    return {
      type: Actions.GENERATE_FORM_POPUP,
      popupId,
      wysiwygPopupMode,
      templateJSON,
    };
  }

  function generateFormPopup(popupId, wysiwygPopupMode) {
    return (dispatch, getState) => {
      const state = getState();
      const templates = state.templates.get('byId');
      const defaultTemplate = templates.get(DEFAULT_TEMPLATE_ID);

      dispatch(_generateFormPopup(popupId, wysiwygPopupMode, JSON.parse(defaultTemplate.get('json'))));
    };
  }

  function updatePopupTemplate(popupId, template, options) {
    return (dispatch) => {
      dispatch(beginUndoGroup(popupId));
      dispatch({
        type: Actions.UPDATE_POPUP_TEMPLATE,
        popupId,
        template,
        options,
      });
      dispatch(endUndoGroup(popupId));
    };
  }

  function _updatePopupGoal(popupId, goal, currentTemplateForGoal, defaultTemplateForGoal, modTemplateJSON, scrapePopupData, templateStatus) {
    return {
      type: Actions.UPDATE_POPUP_GOAL,
      goal,
      popupId,
      currentTemplateForGoal,
      defaultTemplateForGoal,
      modTemplateJSON,
      scrapePopupData,
      templateStatus,
    };
  }

  function updatePopupGoal(popupId, goal, supportEdit, scrapePopupData) {
    return (dispatch, getState) => {
      const state = getState();
      const templatesById = state.templates.get('byId');
      const templatesByGroup = state.templates.get('byGroup');
      const siteId = state.settings.get('siteId');
      const sumoUrl = state.settings.get('sumoUrl');

      // Get template group_id from popup
      const popup = state.popups.get('byId').get(popupId) || Immutable.Map();

      let formType = popup.get('form_type');
      if ([FormTypes.SMART_BAR, FormTypes.WELCOME_MAT].indexOf(formType) === -1) {
        formType = FormTypes.POPUP;
      }

      const currentTemplateId = popup.get('list_builder_template_id');
      const popupTemplate = templatesById.get(currentTemplateId) || Immutable.Map();
      const popupTemplateGroupId = popupTemplate.get('group_id');

      //Get the template status [public, private, ...]
      const templateStatus = popupTemplate.get('status');

      // Get template groups
      const currentTemplateGroup = templatesByGroup.get(popupTemplateGroupId) || Immutable.List();
      const defaultTemplateGroup = templatesByGroup.get(DEFAULT_TEMPLATE_ID) || Immutable.List();

      // Find templates in group that match the goal.
      const currentTemplateForGoal = currentTemplateGroup.find(t => t.get('type') === goal && t.get('form_type') === formType);
      const defaultTemplateForGoal = defaultTemplateGroup.find(t => t.get('type') === goal && t.get('form_type') === formType);
      const validTemplateForGoal = currentTemplateForGoal || defaultTemplateForGoal;
      let modifiedTemplateForGoal;
      let templateJSON;

      // TESTING --- FOR SUPPORT USE ONLY
      let modTemplateJSON;
      if (supportEdit && (state.popups.get('isPopupChanged') || popup.get('created_at'))) {
        if (goal !== 'custom' && validTemplateForGoal) {
          modTemplateJSON = WysiwygTemplates.getModifiedTemplate(
            popup.get('goal'),
            goal,
            popup.get('json'),
            validTemplateForGoal.get('json'),
          );
        }
      }
      if (goal !== 'custom') {
        templateJSON = (currentTemplateForGoal) ?
          currentTemplateForGoal.get('json') : defaultTemplateForGoal.get('json');
      }

      // If scraping site, create modified template, else skip and continue
      return ((scrapePopupData && defaultTemplateForGoal && goal !== 'custom')
        ? StyleTemplate.createScrapedPopupJson(templateJSON, scrapePopupData, siteId, sumoUrl, formType)
        : Promise.resolve())
      .then((result) => {
        if (result) {
          modifiedTemplateForGoal = defaultTemplateForGoal.update('json', () => result[0]);
          dispatch(updateScrapeStatus(result[1]));
        }

        return Promise.all([
          dispatch(beginUndoGroup(popupId)),
          dispatch(_updatePopupGoal(
            popupId,
            goal,
            modifiedTemplateForGoal || currentTemplateForGoal,
            defaultTemplateForGoal,
            modTemplateJSON,
            scrapePopupData,
            templateStatus,
          )),
          dispatch(endUndoGroup(popupId)),
        ]);
      })
      .catch(err => console.log('Error', err));
    };
  }

  function updatePopupSocialChannel(popupId, socialChannel) {
    return (dispatch, getState) => {
      const state = getState();
      const templatesById = state.templates.get('byId');

      const popup = state.popups.get('byId').get(popupId) || Immutable.Map();
      const currentTemplateId = popup.get('list_builder_template_id');
      const currentTemplate = templatesById.get(currentTemplateId) || Immutable.Map();

      dispatch({
        type: Actions.UPDATE_POPUP_SOCIAL_CHANNEL,
        popupId,
        socialChannel,
        currentTemplate,
      });
    }
  }

  function updatePopupStatusFilter(filter) {
    return {
      type: Actions.UPDATE_POPUP_STATUS_FILTER,
      filter,
    }
  }

  function updatePopupFormType(popupId, formType, templates) {
    return {
      type: Actions.UPDATE_POPUP_FORM_TYPE,
      popupId,
      formType,
      templates,
    };
  }

  function updatePopupTextFilter(filter) {
    return {
      type: Actions.UPDATE_POPUP_TEXT_FILTER,
      filter,
    }
  }

  function updateTestTextFilter(filter) {
    return {
      type: Actions.UPDATE_TEST_TEXT_FILTER,
      filter,
    }
  }

  function renamePopup(popupId, newName, options = {}) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const popups = getState().popups;
      let popup = popups.get('byId').get(popupId);
      const { shortcutId } = options;

      if (!popup) {
        popup = popups.get('list').filter(p => p.get('id') === popupId).get(0);

        if (!popup) return Promise.resolve();
      }

      dispatch(_requestPopups());

      popup = popup.toJS();

      return axios.post(`${sumoUrl}/apps/listbuilder/v3/popup/update`, {
        site_id: popup.site_id,
        popup_id: popup.id,
        shortcut_id: shortcutId,
        popup: { name: newName },
      }, _getRequestConfig())

        .then(res => {
          const data = res.data;

          if (!data.success) {
            return dispatch(_errorPopup(popupId, 'update', new Error('Failed to save popup.')));
          }

          return Promise.all([
            dispatch(_receivePopup(data.popup)),
            dispatch(fetchPopups(true)),
          ]).then(() => data.popup);
        })

        .catch(error => {
          _errorPopup(popupId, 'update', error);
          console.log(error);
        });
    }
  }

  function renameVariant(variantId, newName) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const tests = getState().tests;
      const variant = Immutable.fromJS(tests.get('list').toJS())
        .flatten(true)
        .filter(p => p.get('id') === variantId)
        .get(0)
        .toJS();

      dispatch(_requestTests());

      axios.post(`${sumoUrl}/apps/listbuilder/v3/popup/update`, {
        site_id: variant.site_id,
        popup_id: variant.id,
        popup: {name: newName},
      }, _getRequestConfig())

        .then(res => {
          const data = res.data;

          if (!data.success) {
            return dispatch(_errorPopup(variantId, 'update', new Error('Failed to save variant.')));
          }

          return Promise.all([
            dispatch(_receiveTest(data.popup)),
            dispatch(fetchTests(true))
          ]).then(() => data.popup);
        })

        .catch(error => {
          _errorPopup(variantId, 'update', error);
          console.log(error);
        });
    }
  }

  function endTest(testId, variantId) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const tests = getState().tests;
      const variant = Immutable.fromJS(tests.get('list').toJS())
        .flatten(true)
        .filter(p => p.get('test_id') === testId && p.get('variant') === variantId)
        .get(0)
        .toJS();

      axios.post(`${sumoUrl}/apps/listbuilder/v3/test/end`, {
        site_id: variant.site_id,
        test_id: variant.test_id,
        variant: variant.variant
      }, _getRequestConfig())

        .then(res => {
          const data = res.data;

          return Promise.all([
            dispatch(fetchTests(true)),
            dispatch(fetchPopups(true))
          ]).then(() => data);
        })

        .catch(error => {
          console.log(error);
        });
    }
  }

  function archiveTest(testId, variantId) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const tests = getState().tests;
      const variant = Immutable.fromJS(tests.get('list').toJS())
        .flatten(true)
        .filter(p => p.get('test_id') === testId && p.get('variant') === variantId)
        .get(0)
        .toJS();

      axios.post(`${sumoUrl}/apps/listbuilder/v3/test/archive`, {
        site_id: variant.site_id,
        test_id: variant.test_id,
        variant: variant.variant
      }, _getRequestConfig())

        .then(res => {
          const data = res.data;

          return Promise.all([
            dispatch(fetchTests(true)),
            dispatch(fetchPopups(true))
          ]).then(() => data);
        })

        .catch(error => {
          console.log(error);
        });
    }
  }

  function updatePopupStatus(popupId, status) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const popups = getState().popups;
      let popup = popups.get('byId').get(popupId);

      if (!popup) {
        popup = popups.get('list').filter(p => p.get('id') === popupId).get(0);

        if (!popup) return Promise.resolve();
      }

      dispatch(_requestPopups());

      popup = popup.toJS();

      return axios.post(`${sumoUrl}/apps/listbuilder/v3/popup/update`, {
        site_id: popup.site_id,
        popup_id: popup.id,
        popup: {status: status},
      }, _getRequestConfig())

        .then(res => {
          const data = res.data;

          if (!data.success) {
            return dispatch(_errorPopup(popupId, 'update', new Error('Failed to save popup.')));
          }

          return Promise.all([
            dispatch(_receivePopup(data.popup)),
            dispatch(fetchPopups(true)),
            dispatch(_invalidateTestsCache()),
          ]).then(() => data.popup);
        })

        .catch(error => {
          _errorPopup(popupId, 'update', error);
          console.log(error);
        });
    }
  }

  function updateVariantStatus(variantId, status) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const tests = getState().tests;
      const variant = Immutable.fromJS(tests.get('list').toJS())
        .flatten(true)
        .filter(p => p.get('id') === variantId)
        .get(0)
        .toJS();

      if (!variant) return Promise.resolve();

      dispatch(_requestTests());

      return axios.post(`${sumoUrl}/apps/listbuilder/v3/popup/update`, {
        site_id: variant.site_id,
        popup_id: variant.id,
        popup: {status: status},
      }, _getRequestConfig())

        .then(res => {
          const data = res.data;

          if (!data.success) {
            return dispatch(_errorPopup(popupId, 'update', new Error('Failed to save popup.')));
          }

          return Promise.all([
            dispatch(_receiveTest(data.popup)),
            dispatch(fetchTests(true))
          ]).then(() => data.popup);
        })

        .catch(error => {
          _errorPopup(variantId, 'update', error);
          console.log(error);
        });
    }
  }

  function saveVariantWeight(variantId, weight) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const tests = getState().tests;
      const variant = Immutable.fromJS(tests.get('list').toJS())
        .flatten(true)
        .filter(p => p.get('id') === variantId)
        .get(0)
        .toJS();

      dispatch(_requestTests());

      axios.post(`${sumoUrl}/apps/listbuilder/v3/popup/update`, {
        site_id: variant.site_id,
        popup_id: variant.id,
        popup: {weight: weight},
      }, _getRequestConfig())

        .then(res => {
          const data = res.data;

          if (!data.success) {
            return dispatch(_errorPopup(variantId, 'update', new Error('Failed to save variant.')));
          }

          return Promise.all([
            dispatch(_receiveTest(data.popup)),
            dispatch(fetchTests(true))
          ]).then(() => data.popup);
        })

        .catch(error => {
          _errorPopup(variantId, 'update', error);
          console.log(error);
        });
    }
  }

  function updateVariantWeight(testId, variantId, weight) {
    return {
      type: Actions.UPDATE_VARIANT_WEIGHT,
      testId,
      variantId,
      weight,
    };
  }

  function _saveClickTrigger(campaignId) {
    return {
      type: Actions.SAVE_CLICK_TRIGGER,
      campaignId,
    };
  }

  function _receiveClickTrigger(clickTrigger) {
    return {
      type: Actions.RECEIVE_CLICK_TRIGGER,
      clickTrigger,
    };
  }

  function _errorClickTrigger(error) {
    return {
      type: Actions.ERROR_CLICK_TRIGGER,
      error,
    };
  }

  function updateClickTrigger(id, popupId, clickTrigger) {
    return {
      type: Actions.UPDATE_CLICK_TRIGGER,
      id,
      popupId,
      clickTrigger,
    };
  }

  function deleteClickTrigger(id) {
    return {
      type: Actions.DELETE_CLICK_TRIGGER,
      id,
    };
  }

  function createPopup(params = {}) {
    return (dispatch, getState) => {
      const state = getState();
      const siteId = state.settings.get('siteId');

      const json = (
        params.json || state.templates.getIn(['byId', DEFAULT_TEMPLATE_ID, 'json'])
      );

      if (!json) return Promise.resolve(null);

      const popup = _.extend({}, {
        site_id: siteId,
        campaign_id: Util.generateId64(),

        list_builder_template_id: DEFAULT_TEMPLATE_ID,
        animation_id: DEFAULT_TEMPLATE_ID,
        json,

        form_type: FormTypes.POPUP,
        status: 'paused',
        variant: 'A',
        weight: '50',
        popup_mode: 'smart',
        before_show_delay: '5',
        before_show_delay_interval: 'second',
        cookie_lifetime: '1',
        cookie_lifetime_interval: 'month',
        content_width: 'medium',
        device_mode: 'all',
        yield: true,
        goal: 'emails',
        visibility_mode: 'default',
        embed_mode: 'manual',
        auto_embed_placement: 50,
        embed_blackout_status: 'light',
        trigger_percent: 40,
        show_position: 'bottom-right',
        slide_direction: 'up',
        bar_size: 52,
        is_landing_page: false,
        show_type: 'fixed',
        position: 'top',
        auto_responses: [],
        subscriber_notification: true,
      }, params);

      dispatch(_receivePopup(popup));
      return Promise.resolve(popup);
    };
  }

  function _savePopup(popupId) {
    return {
      type: Actions.SAVE_POPUP,
      popupId: popupId,
    };
  }

  function isNewId(id) {
    return (id.indexOf('new-') === 0);
  }

  function previewPopup(popupId) {
    return (dispatch, getState) => {
      const siteId = getState().settings.get('siteId');
      const sumoUrl = getState().settings.get('sumoUrl');
      const { popups } = getState();

      const popup = popups.getIn(['byId', popupId]);
      if (!popup) return Promise.resolve();

      return axios.post(`${sumoUrl}/apps/listbuilder/v3/popup/preview`, {
        site_id: siteId,
        form: popup,
      }, _getRequestConfig()).then((response) => {
        const { success, previewUrl } = response.data;

        if (success && previewUrl) {
          window.open(previewUrl);
        }
      }).catch((err) => {
        console.log(err);
      });
    };
  }

  function savePopup(popupId, dontSetAutoResponseGlobalStatus) {
    return (dispatch, getState) => {
      const { popups, settings } = getState();

      const sumoUrl = settings.get('sumoUrl');
      let popup = popups.get('byId').get(popupId);

      if (!popup) return Promise.resolve();

      popup = popup.toJS();
      // Clean up temporary stuff we don't want going to the server such
      // as temporary ids, etc.
      WysiwygSanitize.cleanPopups(popup.parsedJson);
      popup.json = JSON.stringify(popup.parsedJson);
      // Remove computed parsedJson attr before sending to server.
      popup.parsedJson = undefined;

      // if needed, wipe out our placeholder id so the server can provide a persisted one
      const campaignId = popup.campaign_id;
      if (isNewId(popup.campaign_id)) {
        popup.campaign_id = null;
      }

      // dont add new autoresponses to non email collecting popups
      if (popup.goal !== 'emails') {
        popup.auto_responses = [];
      }

      dispatch(_savePopup(popupId));

      return axios.post(`${sumoUrl}/apps/listbuilder/v3/popup/save`, {
        site_id: popup.site_id,
        popup_id: popupId,
        popup,
      }, _getRequestConfig()).then((res) => {
        const { data } = res;

        if (!data.success) {
          if (data.error) {
            dispatch(_errorPopup(popupId, 'save', data.error));
            console.log(data.error);
            return Promise.reject(data.error);
          }

          throw res.data.errors || new Error('Failed to save popup.');
        }

        // If the id is a new id, the server returns a new id so we delete the temp one.
        if (popupId.indexOf('new-') === 0) dispatch(deletePopup(popupId));

        return Promise.all([
          dispatch(DisplayRuleAppActions.saveDisplayRules(campaignId, data.popup.campaign_id)),
          dispatch(ListActions.saveAllServiceSettings(APP_ID, popup.campaign_id)),
          dispatch(fetchAutoResponseEmails()),
        ]).then(() => {
          dispatch(_receivePopup(data.popup));
          dispatch(_invalidatePopupsCache());
          dispatch(_invalidateTestsCache());

          return data.popup;
        });
      }).catch((error) => {
        dispatch(_errorPopup(popupId, 'save', error));
        console.log(error);
        return Promise.reject(error);
      });
    };
  }

  function validatePopupFreshness(popup) {
    return (dispatch, getState) => {
      if (!popup) return Promise.resolve();

      const sumoUrl = getState().settings.get('sumoUrl');
      const popupId = popup.get('id');

      return axios.post(`${sumoUrl}/apps/listbuilder/v3/popup/validate`, {
          site_id: popup.get('site_id'),
          popup_id: popupId,
          updated_at: popup.get('updated_at'),
        }, _getRequestConfig())

        .then(res => {
          const data = res.data;
          if (!data.success && data.error) {
            dispatch(_errorPopup(popupId, 'validate', data.error));
            console.log(data.error);
            return Promise.reject(data.error);
          }
        })

        .catch(error => {
          dispatch(_errorPopup(popupId, 'validate', error));
          console.log(error);
          return Promise.reject(error);
        });
    }
  }

  function _requestTemplates() {
    return {
      type: Actions.REQUEST_TEMPLATES
    };
  }

  function _receiveTemplates(templates, animations) {
    return {
      type: Actions.RECEIVE_TEMPLATES,
      templates,
      animations,
    };
  }

  function _isSavingTemplate(isSavingMyTemplate) {
    return {
      type: Actions.IS_SAVING_MY_TEMPLATE,
      isSavingMyTemplate,
    };
  }

  function _addNewMyTemplate(template) {
    return {
      type: Actions.SAVE_MY_TEMPLATE,
      template,
    };
  }

  function _errorTemplates(error) {
    return {
      type: Actions.ERROR_TEMPLATES,
      error: error,
    };
  }

  function _receiveDiscountDownloadProgress(status) {
    return {
      type: Actions.RECEIVE_DISCOUNT_DOWNLOAD_PROGRESS,
      status,
    };
  }

  function _receiveDownloadProgress(status) {
    return {
      type: Actions.RECEIVE_DOWNLOAD_PROGRESS,
      status,
    };
  }

  function fetchDownloadProgress(downloadId) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');

      axios.post(`${sumoUrl}/list/export/status`, {
          site_id: siteId,
          download_id: downloadId,
        }, _getRequestConfig())

        .then(res => dispatch(_receiveDownloadProgress(res.data)))

        .catch(error => {
          dispatch(_errorTemplates(error));
          console.log(error);
        });
    }
  }

  /**
   * Fetch popup and animation templates from the database.
   * @param {String} slug - Load templates of type slug ('default') if provided, or all otherwise.
   * @returns {Array} An array of template objects
   */
  function fetchTemplates(slug = false, refreshList) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');
      const existingTemplates = getState().templates.get('byId');
      // Get default templates (slug = 'default') so that additional template loading action may be determined
      const defaultTemplates = getState().templates.get('bySlug').get('default') || Immutable.List();

      /* Do not reload templates if all of them have already been loaded, unless requested.
       * Default templates are fetched first in PopupListView for better DesignView redirect performance (for new users).
       * After default templates have been loaded, all templates are fetched in PopupView.
       */
      if (defaultTemplates && existingTemplates.count() > defaultTemplates.count() && !refreshList) {
        return Promise.resolve(existingTemplates.toJS());
      }

      dispatch(_requestTemplates());

      return axios.post(`${sumoUrl}/apps/listbuilder/v3/templates`, {
        site_id: siteId,
        slug: slug,
      }, _getRequestConfig())

      .then(res => {
        const { templates, animations } = res.data;
        dispatch(_receiveTemplates(templates, animations))
        return Promise.resolve(templates);
      })

      .catch(error => {
        dispatch(_errorTemplates(error));
        console.log(error);
      });
    }
  }

  /**
   * save a new 'my-template' to the database.
   * @param {String} templateId - The template id to be download and save
   * @returns {Array} An array of template objects
   */
  function SaveMyTemplate(templateId, popupId) {
    return (dispatch, getState) => {
      dispatch(_isSavingTemplate(true));
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');

      return axios.post(`${sumoUrl}/apps/listbuilder/v3/my-templates`, {
          template_id: templateId,
          site_id: siteId,
        }, _getRequestConfig()).then(res => {
          const { newMyTemplate } = res.data;

          dispatch(_addNewMyTemplate(newMyTemplate));
          // this way it seems to re render the template list
          dispatch(fetchTemplates(false, true));
          dispatch(_isSavingTemplate(false));

          // select the new template on the my-templates list
          dispatch({
            type: Actions.UPDATE_POPUP_TEMPLATE,
            popupId,
            template: new Immutable.Map(newMyTemplate),
            options: {},
          });
        }).catch(error => {
          $.growlUI('Error download the template...', null, 6000, function() {});
          console.log(error);
          dispatch(fetchTemplates(false, true));
          dispatch(_isSavingTemplate(false));
        });
    }
  }

  function deleteMyTemplate(templateId) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');

      return axios.post(`${sumoUrl}/apps/listbuilder/v3/my-templates/${templateId}/delete`, {
          site_id: siteId,
        }, _getRequestConfig()).then(res => {
          if (!res.data.success) {
            alert('My template could not be found or deleted... ');
          }
          dispatch(fetchTemplates(false, true));
        }).catch(error => {
          $.growlUI('Error deleting the template...', null, 6000, function() {});
          console.log(error);
          dispatch(fetchTemplates(false, true));
        });
    }
  }

  function _saveTemplate(templateId) {
    return {
      type: Actions.SAVE_TEMPLATE,
      templateId,
    }
  }

  // Get the current popup json and save it as the json for the given
  // template id. Used to update templates as an admin.
  function saveTemplate(templateId, popupId) {
    return (dispatch, getState) => {
      const state = getState();
      const sumoUrl = state.settings.get('sumoUrl');
      const immutablePopup = state.popups.get('byId').get(popupId);
      if (!immutablePopup) return Promise.resolve();

      const popup = immutablePopup.toJS();
      dispatch(_saveTemplate(templateId));

      // Clean up temporary stuff we don't want going to the server such
      // as temporary ids, etc.
      WysiwygSanitize.cleanPopups(popup.parsedJson);
      const popupJson = JSON.stringify(popup.parsedJson);

      return axios.post(`${sumoUrl}/apps/listbuilder/v3/template/save`, {
          template_id: templateId,
          json: popupJson,
        }, _getRequestConfig())

        .then(res => {
          dispatch(fetchTemplates(false, true));
        })

        .catch(error => {
          alert('Error saving template...');
          console.log(error);
          // Fetch the templates to clear any saving or error state.
          dispatch(fetchTemplates(false, true));
        });
    }
  }

  function _updateTemplateStatus(templateId) {
    return {
      type: Actions.UPDATE_TEMPLATE_STATUS,
      templateId,
    }
  }

  function updateTemplateStatus(templateId, newStatus) {
    return (dispatch, getState) => {
      const state = getState();
      const sumoUrl = state.settings.get('sumoUrl');
      dispatch(_updateTemplateStatus(templateId));

      return axios.post(`${sumoUrl}/apps/listbuilder/v3/template/save`, {
          template_id: templateId,
          status: newStatus,
        }, _getRequestConfig())

        .then(res => {
          dispatch(fetchTemplates(false, true));
        })

        .catch(error => {
          alert('Error updating template status...');
          console.log(error);
          // Fetch the templates to clear any saving or error state.
          dispatch(fetchTemplates(false, true));
        });
    }
  }

  function renameTemplate(newTemplateName) {
    return (dispatch, getState) => {
      const state = getState();
      const sumoUrl = state.settings.get('sumoUrl');

      return axios.post(`${sumoUrl}/apps/listbuilder/v3/template/rename`, {
        template_id: newTemplateName.id,
        name: newTemplateName.name,
      }, _getRequestConfig())

      .then(() => {
        dispatch(fetchTemplates(false, true));
      })

      .catch(error => {
        console.log(error);
        // Fetch the templates to clear error state
        dispatch(fetchTemplates(false, true));
      });
    }
  }

  function cloneTemplate(templateId, templateName) {
    return (dispatch, getState) => {
      const state = getState();
      const sumoUrl = state.settings.get('sumoUrl');
      const templatesById = state.templates.get('byId');
      const templatesByGroup = state.templates.get('byGroup');

      // Get template group_id
      const template = templatesById.get(templateId) || Immutable.Map();
      const templateGroupId = template.get('group_id') || DEFAULT_TEMPLATE_ID;
      const templateGroup = templatesByGroup.get(templateGroupId) || Immutable.List();

      return axios.post(`${sumoUrl}/apps/listbuilder/v3/template/clone`, {
          // DEFAULT_TEMPLATE_ID is both the default template id and its group_id
          templates: templateGroup.toJS() || [],
          name: templateName,
        }, _getRequestConfig())

        .then(res => {
          dispatch(fetchTemplates(false, true));
        })

        .catch(error => {
          alert('Error cloning template...');
          console.log(error);
          // Fetch the templates to clear error state
          dispatch(fetchTemplates(false, true));
        });
    }
  }

  function uploadForm(file, opts = {}, callback = Function.prototype) {
    return (dispatch, getState) => {
      const { popupId } = opts;
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');
      const data = new FormData();
      const config = _getRequestConfig();

      data.append('site_id', siteId);
      data.append('popup_id', popupId);
      data.append('file', file);

      return axios.post(`${sumoUrl}/apps/listbuilder/v3/popup/import?site_id=${siteId}`, data, config).then((res) => {
        dispatch(fetchPopups(true));
        dispatch(fetchTests(true));
        dispatch(fetchAutoResponseEmails());

        if (res.data.success) {
          callback(true, `Form saved as "${res.data.popupName}"`, res.data.popupId);
        } else {
          callback(false, res.data.message, null);
        }
      }).catch((error) => {
        console.log(error);
        callback('Could not import form: ', error);
      });
    };
  }

  function _requestTests() {
    return {
      type: Actions.REQUEST_TESTS
    };
  }

  function _receiveTests(tests) {
    return {
      type: Actions.RECEIVE_TESTS,
      tests: tests
    };
  }

  function _errorTests(code, error) {
    return {
      type: Actions.ERROR_TESTS,
      code,
      error,
    };
  }

  /**
   * Fetch test data
   * @param {Boolean} refresh If false, assumes cached data should be used
   * @param {Boolean} isProgressiveLoadEnabled If true, makes to calls where the
   * first call is not hydrated with stats data and the second response does
   * have test data hydrated with the stats data
   * @returns {Object} Json test data
   */
  function fetchTests(refresh = false, isProgressiveLoadEnabled = true) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');
      const fetchedAt = getState().tests.get('fetchedAt');
      const page = getState().listbuilderSettings.get('pageTest');
      const limit = getState().listbuilderSettings.get('limitTest');
      const filterStatus = getState().listbuilderSettings.get('statusTest', Immutable.Map());
      const name = getState().tests.get('textFilter');

      const [status] = getFilterGroups(LB_TEST_FILTER_ORDER, filterStatus);

      if (refresh === false) {
        const cacheAge = (Date.now() - fetchedAt) / 1000;

        if (cacheAge <= 300) {
          return Promise.resolve();
        }
      }

      dispatch(_requestTests());

      return axios.post(`${sumoUrl}/apps/listbuilder/v3/tests`, {
        site_id: siteId,
        page,
        limit,
        status,
        name,
        isStatsExcluded: isProgressiveLoadEnabled,
      }, _getRequestConfig())

        .then((res) => {
          dispatch(updateSetting('totalTest', res.data.total));

          // Only make a second request for the same data
          // hydrated with stats if the first call was
          // not hydrated with stats
          if (isProgressiveLoadEnabled) {
            axios.post(`${sumoUrl}/apps/listbuilder/v3/tests`, {
              site_id: siteId,
              page,
              limit,
              status,
              name,
              isStatsExcluded: false,
            }, _getRequestConfig())
            .then((fullResponse) => {
              dispatch(_receiveTests(fullResponse.data.tests));
            });
          }

          return dispatch(_receiveTests(res.data.tests));
        })
        .catch(error => {
          dispatch(_errorTests('fetch', error));
          console.log(error);
        });
    };
  }

  function _requestTest() {
    return {
      type: Actions.REQUEST_TEST
    };
  }

  function _receiveTest(test) {
    return {
      type: Actions.RECEIVE_TEST,
      test: test
    };
  }

  function _errorTest(testId, error) {
    return {
      type: Actions.ERROR_TEST,
      test_id: testId,
      error: error
    };
  }

  function fetchTest(testId) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');

      dispatch(_requestTest());

      return axios.post(`${sumoUrl}/apps/listbuilder/v3/test/load`, {
          site_id: siteId,
          test_id: testId,
        }, _getRequestConfig())

        .then(res => dispatch(_receiveTest(res.data.test)))

        .catch(error => {
          dispatch(_errorTest(testId, error));
          console.log(error);
        });
    }
  }

  function _requestTestStats(testId) {
    return {
      type: Actions.REQUEST_TEST_STATS,
      test_id: testId,
    };
  }

  function _receiveTestStats(testId, data) {
    return {
      type: Actions.RECEIVE_TEST_STATS,
      test_id: testId,
      data: data,
    };
  }

  function _errorTestStats(testId, error) {
    return {
      type: Actions.ERROR_TEST_STATS,
      test_id: testId,
      error: error,
    };
  }

  function fetchTestStats(testId) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');

      dispatch(_requestStats());

      return axios.post(`${sumoUrl}/apps/listbuilder/v3/${testId}/stats`, {
          site_id: siteId,
        }, _getRequestConfig())

        .then(res => dispatch(_receiveTestStats(testId, res.data.data)))

        .catch(error => {
          dispatch(_errorTestStats(testId, error));
          console.log(error);
        });
    }
  }

  function _requestStats(period) {
    return {
      type: Actions.REQUEST_STATS,
      period,
    };
  }

  function _receiveStats(period, objectId, data) {
    return {
      type: Actions.RECEIVE_STATS,
      period,
      objectId,
      data,
    };
  }

  function _errorStats(period, error) {
    return {
      type: Actions.ERROR_STATS,
      period,
      error: _.isString(error) ? error : (error.hasOwnProperty('message') ? error.message : error + ''),
    };
  }

  function fetchStats(period, objectId) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');
      const overall = getState().stats.get('overall');

      if (overall.has(period) && overall.get(period).has(objectId) && overall.get(period).get(objectId).has('datasets')) return Promise.resolve();

      dispatch(_requestStats(period));

      return axios.post(`${sumoUrl}/apps/listbuilder/v3/stats`, {
        site_id: siteId,
        period,
        object_id: objectId,
      }, _getRequestConfig()).then((res) => {
        const { data } = res;

        if (!data.success) {
          throw new Error(data.error || 'Error fetching stats');
        }

        dispatch(_receivePopupIds(res.data.variants));
        return dispatch(_receiveStats(period, objectId, res.data.data));
      }).catch((error) => {
        dispatch(_errorStats(period, error));
        console.log(error);
      });
    };
  }

  function _requestSettings() {
    return {
      type: Actions.REQUEST_SETTINGS,
    };
  }

  function _invalidatePopupsCache() {
    return {
      type: Actions.INVALIDATE_POPUPS_CACHE,
    };
  }

  function _invalidateTestsCache() {
    return {
      type: Actions.INVALIDATE_TESTS_CACHE,
    };
  }

  function _receiveSettings(settings) {
    return {
      type: Actions.RECEIVE_SETTINGS,
      settings,
    };
  }

  function _errorSettings(error) {
    return {
      type: Actions.ERROR_SETTINGS,
      error,
    };
  }

  function fetchSettings() {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');

      dispatch(_requestSettings());

      return axios.post(`${sumoUrl}/apps/listbuilder/v3/settings`, {
        site_id: siteId,
      }, _getRequestConfig())

      .then(res => dispatch(_receiveSettings(res.data.settings)))

      .catch(error => {
        dispatch(_errorSettings(error));
        console.log(error);
      });
    }
  }

  function updateSetting(setting, value) {
    return {
      type: Actions.UPDATE_SETTING,
      setting,
      value
    };
  }

  function updateAppState(state, value) {
    return {
      type: Actions.UPDATE_APP_STATE,
      state,
      value,
    };
  }

  function resizeModal(modalBodyHeight) {
    return {
      type: Actions.RESIZE_MODAL,
      modalBodyHeight: modalBodyHeight
    };
  }

  // keys to be ignored for each component when checking for design changes
  const componentDesignNonUndoableKeys = ['id', 'defaultAspectRatio', 'errors'];

  // keys to be considered for each popup when checking for design changes
  const popupDesignUndoableKeys = ['animation_id', 'content_width'];

  /**
   * @return {Boolean} returns true if any changes to the given component are design related
   */
  function hasComponentDesignChanged(componentA, componentB) {
    const componentADesign = _.omit(componentA, componentDesignNonUndoableKeys);
    const componentBDesign = _.omit(componentB, componentDesignNonUndoableKeys);
    const hasChanged = !_.isEqual(componentADesign, componentBDesign);

    return hasChanged;
  }

  /**
   * @return {Boolean} returns true if any changes to the given step are design related
   */
  function hasStepDesignChanged(stepA, stepB) {
    let hasChanged = false;

    if (stepA !== undefined && stepB !== undefined) {
      const componentsA = stepA.components;
      const componentsB = stepB.components;

      // sometimes the components are undefined?
      if (componentsA !== componentsB) {
        // if the number of components is different, we've changed
        if (componentsA.length !== componentsB.length) {
          hasChanged = true;
        } else {
          for (let i = 0, l = componentsA.length; i < l; i += 1) {
            if (hasComponentDesignChanged(componentsA[i], componentsB[i])) {
              hasChanged = true;
              break;
            }
          }
        }
      }
    } else {
      // one of them is undefined at this point
      hasChanged = stepA !== stepB;
    }

    return hasChanged;
  }

  /**
   * @return {Boolean} returns true if any changes to the given popup states are design related
   */
  function hasDesignChanged(popupStateA, popupStateB) {
    const popupA = popupStateA.toJS();
    const popupB = popupStateB.toJS();
    const popupADesign = _.pick(popupA, popupDesignUndoableKeys);
    const popupBDesign = _.pick(popupB, popupDesignUndoableKeys);
    const popupAParsedJson = popupA.parsedJson;
    const popupBParsedJson = popupB.parsedJson;
    let hasChanged = false;

    // If goal has changed to/from custom, no undo should be added to stack
    if (popupA.goal === 'custom' || popupB.goal === 'custom') return false;

    if (!_.isEqual(popupADesign, popupBDesign)) { // check if the designable keys have changed
      hasChanged = true;
    } else if (!_.isEqual(popupAParsedJson.steps, popupBParsedJson.steps)) {
      hasChanged = true;
    } else { // each state has the same steps, now check each step
      Object.keys(popupAParsedJson).forEach((step) => {
        if (hasStepDesignChanged(popupAParsedJson[step], popupBParsedJson[step])) {
          hasChanged = true;
        }
      });
    }

    return hasChanged;
  }

  let undoGroup;

  /**
   * Creates an action to register an undo
   * @param  {string} popupId                   The id of the popup
   * @param  {object.immutable.map} popupState  The state of the popup to return to
   * @param  {string} selectedComponentId       The id of the component to select when executing the undo
   */
  function registerUndo(popupId, popupState, selectedComponentId) {
    return {
      type: Actions.REGISTER_UNDO,
      popupId,
      popupState,
      selectedComponentId,
    };
  }

  function beginUndoGroup(popupId) {
    return (dispatch, getState) => {
      const state = getState();

      // if we're not already in an undo group, store the state of the popup
      if (!undoGroup) {
        undoGroup = {
          popupState: state.popups.get('byId').get(popupId),
          selectedComponentId: state.listbuilderAppState.get('wysiwygSelectedComponentId'),
          popupId,
        };
      }

      return state;
    };
  }

  function endUndoGroup(popupId) {
    return (dispatch, getState) => {
      const state = getState();
      if (hasDesignChanged(undoGroup.popupState, state.popups.get('byId').get(popupId))) {
        dispatch(registerUndo(
          undoGroup.popupId,
          undoGroup.popupState,
          undoGroup.selectedComponentId,
        ));
      }

      // the group is closed, wipe out the initial state of the group
      undoGroup = undefined;

      return state;
    };
  }

  /**
   * Dispatch the update popup action to the popups.es6 reducer file
   * @param {string} popupId - The id of the popup being edited
   * @param {Object} popup - The key-value pair for the popup database property and its new value
   */
  function updatePopup(popupId, popup) {
    return (dispatch) => {
      dispatch(beginUndoGroup(popupId));
      dispatch({
        type: Actions.UPDATE_POPUP,
        popupId,
        popup,
      });
      dispatch(endUndoGroup(popupId));
    };
  }

  function updatePopupJson(popupId, popupStep, popupPartial) {
    return (dispatch) => {
      dispatch(beginUndoGroup(popupId));
      dispatch({
        popupId,
        popupStep,
        type: Actions.UPDATE_POPUP_JSON,
        popup: popupPartial,
      });
      dispatch(endUndoGroup(popupId));
    };
  }

  function updatePopupJsonComponent(popupId, componentId, componentPartial, shouldBypassUndo) {
    return (dispatch, getState) => {
      if (!shouldBypassUndo) {
        dispatch(beginUndoGroup(popupId));
      }
      dispatch({
        popupId,
        componentId,
        type: Actions.UPDATE_POPUP_JSON_COMPONENT,
        component: componentPartial,
        shouldBypassUndo,
      });
      if (!shouldBypassUndo) {
        dispatch(endUndoGroup(popupId));
      }
    };
  }

  /**
   * @param {boolean} migrating Indicates migration is starting, false when import source is acting only to provide context
   */
  function updateImportSource(source, migrating) {
    return (dispatch) => {
      dispatch({
        type: Actions.UPDATE_IMPORT_SOURCE,
        source,
        migrating,
      });
    };
  }

  /**
   * Updates the appViewLaunchedStatus for determining correct routing to PopupListView or DesignView
   * @param {boolean} isLaunched Launch state for AppView mounting; true if mounting, false if other views mount.
   */
  function updateAppViewLaunchedStatus(isLaunched = true) {
    return (dispatch) => {
      dispatch({
        type: Actions.UPDATE_APPVIEW_LAUNCHED_STATUS,
        appViewLaunchedStatus: isLaunched,
      });
    }
  }

  function updateImportStatus(status) {
    return (dispatch) => {
      dispatch({
        type: Actions.UPDATE_IMPORT_STATUS,
        status,
      });
    };
  }

  function updateMigrateStatus(migrate, status) {
    return (dispatch) => {
      dispatch({
        type: Actions.UPDATE_MIGRATE_STATUS,
        migrate,
        status,
      });
    }
  }

  /**
   * Starts an undo session for the given popup
   * @param {string}  popupId The id of the popup
   */
  function startUndoSession(popupId) {
    return {
      type: Actions.START_UNDO_SESSION,
      popupId,
    };
  }

  /**
   * Ends the active undo session for the popup
   * @param   {string} popupId The id of the popup to start an undo session for
   * @param  {boolean} shouldRollbackSession If true the undo/redo will be restored to the state at the start of the session
   */
  function endUndoSession(popupId, shouldRollbackSession) {
    return {
      type: Actions.END_UNDO_SESSION,
      popupId,
      shouldRollbackSession,
    };
  }

  function undo(popupId) {
    return (dispatch, getState) => {
      const state = getState();

      // get the top undo
      const undoStack = state.popups.getIn(['undoStackById', popupId]);

      if (undoStack) {
        const undoItem = undoStack.last();

        if (undoItem) {
          // dispatch the undo
          dispatch({
            popupId,
            type: Actions.UNDO_POPUP_CHANGE,
            selectedComponentId: state.listbuilderAppState.get('wysiwygSelectedComponentId'),
          });

          // if a selected component id was provided, reselect it
          if (undoItem.selectedComponentId) {
            dispatch(updateAppState('wysiwygSelectedComponentId', undoItem.selectedComponentId));
          }
        }
      }
    };
  }

  function redo(popupId) {
    return (dispatch, getState) => {
      const state = getState();

      // get the top undo
      const redoStack = state.popups.getIn(['redoStackById', popupId]);

      if (redoStack) {
        const redoItem = redoStack.last();

        if (redoItem) {
          // dispatch the redo
          dispatch({
            popupId,
            type: Actions.REDO_POPUP_CHANGE,
            selectedComponentId: redoItem.selectedComponentId,
          });

          // if a selected component id was provided, reselect it
          if (redoItem.selectedComponentId) {
            dispatch(updateAppState('wysiwygSelectedComponentId', redoItem.selectedComponentId));
          }
        }
      }
    };
  }

  function _errorAutoResponse(error) {
    return {
      type: Actions.ERROR_AUTO_RESPONSE,
      error: error,
    };
  }

  function _requestAutoResponseEmails() {
    return {
      type: Actions.REQUEST_AUTO_RESPONSE_EMAILS,
    };
  }

  function _receiveAutoResponseEmails(autoResponseEmails) {
    return {
      type: Actions.RECEIVE_AUTO_RESPONSE_EMAILS,
      autoResponseEmails,
    };
  }

  function _receiveAutoResponseTemplates(autoResponseTemplates) {
    return {
      type: Actions.RECEIVE_AUTO_RESPONSE_TEMPLATES,
      autoResponseTemplates,
    };
  }

  function _addAutoResponseEmail(autoResponseEmail) {
    return {
      type: Actions.ADD_AUTO_RESPONSE_EMAIL,
      autoResponseEmail,
    };
  }

  function _deleteAutoResponseEmail(autoResponseEmailId) {
    return {
      type: Actions.DELETE_AUTO_RESPONSE_EMAIL,
      autoResponseEmailId,
    };
  }

  function _addAutoResponseRule(objectId, variantId, autoResponseRule) {
    return {
      type: Actions.ADD_AUTO_RESPONSE_RULE,
      autoResponseRule,
      objectId,
      variantId,
    };
  }

  function _removeAutoResponseRule(objectId, variantId, autoResponseRuleId) {
    return {
      type: Actions.REMOVE_AUTO_RESPONSE_RULE,
      autoResponseRuleId,
      objectId,
      variantId,
    };
  }

  function _toggleAutoResponseRuleStatus(objectId, variantId, autoResponseRuleId) {
    return {
      type: Actions.TOGGLE_AUTO_RESPONSE_RULE_STATUS,
      autoResponseRuleId,
      objectId,
      variantId,
    };
  }

  function _setAutoResponseRulesStatusFromList(objectId, variantId, status, onlyOneOn) {
    return {
      type: Actions.SET_AUTO_RESPONSE_RULES_STATUS_FROM_LIST,
      status,
      objectId,
      variantId,
      onlyOneOn,
    };
  }

  function _updateAutoResponseRuleName(objectId, variantId, autoResponseEmail) {
    return {
      type: Actions.UPDATE_AUTO_RESPONSE_RULE_NAME,
      autoResponseEmail,
      objectId,
      variantId,
    };
  }

  function fetchAutoResponseEmails() {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');

      dispatch(_requestAutoResponseEmails());

      axios.post(`${sumoUrl}/autoresponse/email/load`, {
        site_id: siteId,
        app_id: APP_ID,
      }, _getRequestConfig())

      .then((res) => {
        dispatch(_receiveAutoResponseEmails(res.data.autoResponseEmails));
        dispatch(_receiveAutoResponseTemplates(res.data.autoResponseTemplates));
      })

      .catch((error) => {
        console.log(error);
      });
    }
  }

  function validateCustomDomain(domain, subUserId) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');

      return axios.post(`${sumoUrl}/autoresponse/validate`, {
        site_id: siteId,
        domain: domain,
        sub_user_id: subUserId,
      }, _getRequestConfig())

      .then(res => {
        const data = res.data;

        if (!data.success) throw new Error(data.error || 'Failed to validate domain.');

        return data;
      })
      .catch((error) => {
        console.log(error);
        return Promise.reject(error);
      });
    };
  }

  function saveAutoResponseEmail(objectId, variantId, autoResponseEmail, createRule) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');

      let subUserId;
      if (autoResponseEmail.sumoMailDomain && autoResponseEmail.sumoMailDomain.subuser_id) {
        subUserId = autoResponseEmail.sumoMailDomain.subuser_id;
      }

      const {
        id,
        name,
        subject,
        preview_text: previewText,
        body,
        custom_sender,
        default: isDefault,
        reply_to,
        template_id,
        footerGroupName,
        footerAddress,
        footerBgColor,
        footerTextColor,
        headerImage,
        footerAltText,
        template,
        shortcutId,
      } = autoResponseEmail;

      return axios.post(`${sumoUrl}/autoresponse/email/save`, {
        email_id: id,
        name,
        subject,
        preview_text: previewText,
        body,
        custom_sender,
        reply_to,
        template_id,
        site_id: siteId,
        app_id: APP_ID,
        object_id: objectId,
        create_rule: createRule,
        default: isDefault,
        subuser_id: subUserId,
        footerGroupName,
        footerAddress,
        footerBgColor,
        footerTextColor,
        headerImage,
        footerAltText,
        template,
        shortcut_id: shortcutId,
      }, _getRequestConfig())

      .then((res) => {
        const data = res.data;

        if (!data.success) {
          return dispatch(_errorAutoResponse(new Error('Failed to save auto response email.')));
        }

        autoResponseEmail.id = data.autoResponseEmail.id;
        autoResponseEmail.sumoMailDomain = data.sumoMailDomain;

        dispatch(_addAutoResponseEmail(autoResponseEmail));
        dispatch(_updateAutoResponseRuleName(objectId, variantId, autoResponseEmail));

        if ('autoResponseRule' in data && data.autoResponseRule) {
          dispatch(_addAutoResponseRule(objectId, variantId, data.autoResponseRule));
        }
        return Promise.resolve(autoResponseEmail);
      })
      .catch((error) => {
        _errorAutoResponse(error);
        console.log(error);
      });
    };
  }

  function deleteAutoResponseEmail(objectId, variantId, autoResponseEmailId) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');

      return axios.post(`${sumoUrl}/autoresponse/email/delete`, {
        site_id: siteId,
        email_id: autoResponseEmailId,
        object_id: objectId,
      }, _getRequestConfig())

      .then(res => {
        const { data } = res;

        if (!data.success) {
          return dispatch(_errorAutoResponse(new Error('Failed to delete auto response email.')));
        }

        dispatch(_deleteAutoResponseEmail(autoResponseEmailId));
        if('auto_response_rule_id' in data && data.auto_response_rule_id) {
          dispatch(_removeAutoResponseRule(objectId, variantId, data.auto_response_rule_id));
        }

        return Promise.resolve();
      });
    };
  }

  function addAutoResponseRule(objectId, variantId, emailId) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');
      const state = getState();

      axios.post(`${sumoUrl}/autoresponse/rule/create`, {
          site_id: siteId,
          app_id: APP_ID,
          email_id: emailId,
          object_id: objectId,
        }, _getRequestConfig())
        .then(res => {
          var data = res.data;
          if (!data.success) {
            return dispatch(_errorAutoResponse(new Error('Failed to create auto response rule.')));
          }
          dispatch(_addAutoResponseRule(objectId, variantId, data.autoResponseRule));
        })
        .catch(error => {
          _errorAutoResponse(error);
          console.log(error);
        });
    };
  }

  function removeAutoResponseRule(objectId, variantId, autoResponseRuleId) {
    return (dispatch, getState) => {
      dispatch(_removeAutoResponseRule(objectId, variantId, autoResponseRuleId));
    };
  }

  function toggleAutoResponseRuleStatus(objectId, variantId, autoResponseRuleId) {
    return (dispatch, getState) => (
      dispatch(_toggleAutoResponseRuleStatus(objectId, variantId, autoResponseRuleId))
    );
  }

  function setAutoResponseRulesStatusFromList(objectId, variantId, status, onlyOneOn) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');
      const state = getState();

      axios.post(`${sumoUrl}/autoresponse/rule/status`, {
          only_one_on: onlyOneOn,
          object_id: objectId,
          site_id: siteId,
          status: status,
        }, _getRequestConfig())
        .then(res => {
          var data = res.data;
          if (!data.success) {
            return dispatch(_errorAutoResponse(new Error('Failed to set auto response rule status.')));
          }
          dispatch(_setAutoResponseRulesStatusFromList(objectId, variantId, status, onlyOneOn));
        })
        .catch(error => {
          _errorAutoResponse(error);
          console.log(error);
        });
    };
  }

  function sendAutoResponseTestEmail(objectId, variantId, emailAddress) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');
      const popupsById = getState().popups.get('byId').toJS();
      const popup = _.findWhere(popupsById, { id: variantId });
      const rules = popup.auto_responses || [];
      const activeRules = [];
      const newRules = [];

      _.each(rules, (rule) => {
        if (!rule.id && rule.email_id) {
          newRules.push(rule.email_id)
        } else if(rule.status !== 'deleted') {
          activeRules.push(rule.id);
        }
      });

      axios.post(`${sumoUrl}/autoresponse/rule/test`, {
        site_id: siteId,
        app_id: APP_ID,
        email_address: emailAddress,
        rule_ids: activeRules,
        new_rule_ids: newRules,
      }, _getRequestConfig())
      .then(res => {
        var data = res.data;
        if (!data.success) {
          return dispatch(_errorAutoResponse(new Error('Failed to send auto response test email.')));
        }
      })
      .catch(error => {
        _errorAutoResponse(error);
        console.log(error);
      });
    };
  }

  function fetchAutoResponsePreview(autoResponseEmail) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');
      const noSumoBranding = getState()
        .appstore
        .getIn(['features', FEATURES.NO_SUMO_BRANDING], false);
      const {
        body,
        subject,
        footerGroupName,
        footerAddress,
        footerBgColor,
        footerTextColor,
        headerImage,
        footerAltText,
        template,
      } = autoResponseEmail;

      return axios.post(`${sumoUrl}/autoresponse/email/preview`, {
        site_id: siteId,
        body,
        subject,
        noSumoBranding,
        footerGroupName,
        footerAddress,
        footerBgColor,
        footerTextColor,
        headerImage,
        footerAltText,
        template,
      }, _getRequestConfig())

      .then(res => {
        const { html } = res.data;
        return Promise.resolve(html);
      })

      .catch(error => {
        console.log(error);
      });
    }
  }

  function acknowledgeAutoResponseError() {
    return {
      type: Actions.ACK_ERROR_AUTO_RESPONSE,
    };
  }

  function validatePushSubdomainName(subdomainName) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');

      return axios.post(`${sumoUrl}/push/subdomain`, {
        site_id: siteId,
        subdomain_name: subdomainName,
      }, _getRequestConfig())

      .then((res) => {
        const data = res.data;

        if (!data.success) throw new Error(data.error || 'Failed to validate subdomain.');

        return data;
      })
      .catch((error) => {
        console.log(error);
        return Promise.reject(error);
      });
    };
  }

  function upgrade(api) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');
      const isPro = getState().listbuilderSettings.get('isPro');
      const cartId = getState().appstore.get('cartId');
      const userId = api.properties.user;
      const productId = 'be7b9929-9103-415e-878c-dabe22fbdb8a'; // Sumo Big Monthly
      const eligibleUpgrades = [
        '5f1c120e-e17e-45a6-be72-a2d875251978', // Sumo Big Yearly
        'be7b9929-9103-415e-878c-dabe22fbdb8a', // Sumo Big Monthly
        '01e6e92d-be25-48fd-9e30-2db5f26f6f8e', // Tier 4 Monthly
        'df678d1a-5a94-446c-a8cf-c1dc3d81ee54', // Tier 4 Yearly
        '3c763196-4931-462c-b7e7-12e6f4ebfbc9', // eCommerce Monthly
        'd722238c-17d3-4e6a-9033-03811f48e7b5', // eCommerce Yearly
        '821716de-f9cf-4813-afd7-d0857a229cfa', // eCommerce Monthly 2018
        '058b4884-11be-4f1e-991c-942e03b0f05f', // eCommerce Yearly 2018
        '96ff6357-e139-4fda-9801-7136e6cc0a3d', // eCommerce Monthly Aug 2018
        'de9fc582-7240-4e34-8fb7-77789bc6d821', // eCommerce Yearly Aug 2018
      ];

      if (isPro) {
        // Show switch tier preview
        dispatch(updateDiscountSetting('loading', true));
        return axios.post(`${sumoUrl}/api/app_store/subscriptions/load`, {
          site_id: siteId,
          user_id: userId,
        }, _getRequestConfig()).then((res) => {
          if (!res.data.success) {
            throw new Error(data);
          }

          let subscriptions = res.data.subscriptions;
          if (res.data.attachmentEligibleSubscriptions && res.data.attachmentEligibleSubscriptions.length) {
            subscriptions = subscriptions.concat(res.data.attachmentEligibleSubscriptions);
          }

          return axios.post(`${sumoUrl}/api/app_store/subscriptions/subscription/load`, {
            user_id: userId,
            site_id: siteId,
            subscription_id: _.pluck(subscriptions, 'id'),
          }, _getRequestConfig()).then((res) => {
            const data = res.data;
            const subscriptions = data.subscriptions;

            let subscriptionToUpgrade = null;
            let newProductId;
            for (let i = 0; i < subscriptions.length; i++) {
              const subscription = subscriptions[i].subscription;
              const upgrades = subscription.upgrades ? subscription.upgrades.filter(upgrade => eligibleUpgrades.indexOf(upgrade.id) > -1) : []
              let hasUpgrade = !!upgrades.length;

              if (hasUpgrade) {
                newProductId = _.intersection(_.pluck(upgrades, 'id'), eligibleUpgrades)[0];
                subscriptionToUpgrade = subscription;
                break;
              }
            }

            if (!subscriptionToUpgrade) {
              dispatch(updateDiscountSetting('loading', false));
              return Promise.resolve();
            }

            return axios.post(`${sumoUrl}/api/app_store/subscriptions/switchpreview`, {
              site_id: siteId,
              user_id: userId,
              inventory_id: subscriptionToUpgrade.id,
              new_product_id: newProductId
            }, _getRequestConfig()).then((res) => {
              return Promise.all([
                dispatch(updateDiscountSetting('loading', false)),
                dispatch(updateSetting('newProductId', newProductId)),
                dispatch(updateSetting('inventoryId', subscriptionToUpgrade.id)),
                dispatch(_receiveSwitchPreview(res.data.preview)),
              ]);
            }).catch(console.log);
          }).catch(console.log);
        }).catch(error => {
          dispatch(_errorProTiers(error));
          console.log(error);
        });
      } else {
        // Straight to Sumo Big checkout
        api.emit('purchase', {
          productId: productId,
          collectionId: 'sumome-pro-upgrades',
          cartId: cartId,
          done: this.onPurchase,
          onWindowClose: () => {
            return Promise.all([
              dispatch(DiscountAppActions.fetchDiscountSettings()),
              dispatch(DiscountAppActions.fetchDiscountCampaigns()),
            ]);
          },
          iSrc: 'discount-codes',
        });
      }
    };
  }

  function _receiveSwitchPreview(switchPreview) {
    return {
      type: Actions.RECEIVE_SWITCH_PREVIEW,
      switchPreview,
    };
  }

  function switchPlan(api, src) {
    return (dispatch, getState) => {
      const sumoUrl = getState().settings.get('sumoUrl');
      const siteId = getState().settings.get('siteId');
      const switchPreview = getState().listbuilderSettings.get('switchPreview');
      const inventoryId = getState().listbuilderSettings.get('inventoryId');
      const newProductId = getState().listbuilderSettings.get('newProductId');
      const userId = api.properties.user;

      dispatch(updateDiscountSetting('loading', true));
      return axios.post(`${sumoUrl}/api/app_store/subscriptions/switchplan`, {
        site_id: siteId,
        user_id: userId,
        inventory_id: inventoryId,
        new_product_id: newProductId,
        prorate_date: switchPreview.get('prorateDate'),
        idempotencyKey: switchPreview.get('idempotencyKey'),
        src,
      }, _getRequestConfig()).then((res) => {
        const data = res.data;

        if (!data.success) {
          throw new Error ('Failed to switch plan.');
        }

        api.emit('restartApp', APP_ID);
        return Promise.all([
          dispatch(updateDiscountSetting('loading', false)),
          dispatch(updateSetting('switchPreview', null)),
        ]);
      }).catch(console.log);
    };
  }

  return {
    endTest,
    archiveTest,
    createPopup,
    fetchTestPopups,
    fetchPopup,
    fetchPopups,
    updatePopup,
    updatePopupJson,
    updatePopupJsonComponent,
    updateImportSource,
    updateImportStatus,
    updateMigrateStatus,
    previewPopup,
    savePopup,
    validatePopupFreshness,
    duplicatePopup,
    deletePopup,
    generateFormPopup,
    startUndoSession,
    endUndoSession,
    undo,
    redo,
    updatePopupTemplate,
    updatePopupGoal,
    updatePopupSocialChannel,
    updatePopupStatusFilter,
    updatePopupTextFilter,
    updatePopupStatus,
    updatePopupFormType,
    updateScrapeStatus,
    renamePopup,
    renameVariant,
    updateVariantWeight,
    updateVariantStatus,
    saveVariantWeight,

    updateListBuilderCandidates,
    updateScrollBoxCandidates,
    updateSmartBarCandidates,
    updateWelcomeMatCandidates,
    updatePopupRowLayout,

    updateClickTrigger,
    deleteClickTrigger,

    createTest,
    fetchTest,
    fetchTests,
    addTestVariant,
    duplicateTestVariant,
    updateTestTextFilter,
    cloneVariant,

    fetchStats,
    fetchTestStats,

    fetchTemplates,
    saveTemplate,
    cloneTemplate,
    renameTemplate,
    updateTemplateStatus,

    SaveMyTemplate,
    deleteMyTemplate,

    uploadForm,

    fetchDownloadProgress,

    fetchSettings,
    updateSetting,

    updateAppState,
    resizeModal,

    fetchAutoResponseEmails,
    saveAutoResponseEmail,
    deleteAutoResponseEmail,
    addAutoResponseRule,
    removeAutoResponseRule,
    toggleAutoResponseRuleStatus,
    setAutoResponseRulesStatusFromList,
    sendAutoResponseTestEmail,
    fetchAutoResponsePreview,
    acknowledgeAutoResponseError,

    validateCustomDomain,
    updateAppViewLaunchedStatus,

    upgrade,
    switchPlan,

    validatePushSubdomainName,

    // Unpack lib actions so we can reference AppActions only in the app.
    ...ListActions,
  };
});
